import React from 'react';
import classnames from 'classnames';

import * as styles from './Card.module.css';

export function Card({children, noSpacing = false}) {
  const className = classnames(styles.Card, noSpacing && styles.NoSpacing);

  return <div className={className}>{children}</div>;
}
